import React,{useState,useContext} from 'react'
import axios from 'axios'
import signin from "../images/signin.svg"
import { NavLink, useNavigate } from 'react-router-dom'
import { UserContext } from '../App'

function Signin() {
  const {state,dispatch} = useContext(UserContext);
  const navigate = useNavigate();
  const [user, setUser] = useState({
    email:"",password:""
  });

  let name,value;
  const handleInputs = (e) =>{
    name = e.target.name;
    value = e.target.value;

    setUser(values => ({...values, [name]: value}))

}
  const signinUser = async (e)=>{
    e.preventDefault();
    const {email, password} = user;
    axios.post("/signin",user)
    .then(()=>{
      dispatch({type:"USER", payload:true});
      console.log("Logged In Succesfully");
      window.alert("Logged In Succesfully");
      navigate("/")})
    .catch((e)=>{      console.log("Invalid Credentials");
    window.alert("Invalid Credentials");})
  }
  return (
    <>
      <section style={{minHeight: "100vh"}} className='signin bg-light border-top p-5'>
        <div className='container bg-white border mx-auto rounded p-5'>
          <div className='signin-content '>
            <div className='signin-form'>
              <h2 className='text-center'>Sign In</h2>
              <div className='row pt-2'>
              <div className='col-lg-6 '>
                    <img src={signin} alt='signin'/>
                    <NavLink to='/register'>Register Yourself</NavLink>
                  </div>
                  <div className='col-lg-6 my-auto'>
                  <h5 className='text-center my-4'>Enter Your Credentials</h5>
                  <form>
  <div class="form-group row">
    <div class="col-sm-12">
      <input type="email" name="email" class="form-control" id="email" 
      value={user.email}
      onChange={handleInputs}
      placeholder='Email Address'/>
    </div>
    </div>
  <div class="form-group row">
    <div class="col-sm-12">
      <input type="password" name="password"  class="form-control" id="password" 
      value={user.password}
      onChange={handleInputs}
      placeholder='Password'/>
    </div>
  </div>
  <div class="form-group row">
    <div class="col-sm-12 btn-group btn-group-justified">
      <button type="submit" onClick={signinUser} class="btn btn-justified btn-dark">Sign In</button>
    </div>
  </div>
</form>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Signin